export default "__VITE_ASSET__BUUm4$r4__"